import { withTranslation } from 'react-i18next'

import ReviewsSurveyOpenEndedQuestionSection from './ReviewsSurveyOpenEndedQuestionSection'

export default withTranslation('admin')(ReviewsSurveyOpenEndedQuestionSection)
